import AxiosClient from '../../../../services/axios.services';

class SurveyTemplateServices {
  getSurveyTemplateQuestions = (params) =>
    AxiosClient.get("/api/app/Survey_Question/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getSurveyTemplateQuestionById = (id) =>
    AxiosClient.get(`/api/app/SurveyQuestion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveSurveyTemplateQuestion = (data) =>
    AxiosClient.post("/api/app/SurveyQuestion/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  editSurveyTemplateQuestion = (id, data) =>
    AxiosClient.put(`/api/app/SurveyQuestion/${id}/`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  updateSurveyTemplateQuestionSecuence = (data) =>
    AxiosClient.post("/api/app/QuestionUpdateCustom/", data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteSurveyTemplateQuestion = (id) =>
    AxiosClient.delete(`/api/app/SurveyQuestion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new SurveyTemplateServices();